export default __webpack_public_path__ + "static/media/Login-Page-Image.3e0aba4d.png";